import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles/index';
import TextField from '@material-ui/core/TextField';
import FMPAddButton from './FMPAddButton';

const styles = () => ({
	title : {
		display : 'flex',
		alignItems : 'flex-end'
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
});

class FMPHeadline extends PureComponent {
	render () {
		const {
			label, value, classes, onChange,
			url, buttonText, canMakeUpdates,
		} = this.props;
		return (
			<Grid container spacing={3}>
				<Grid item xs={8}>
					<Typography variant="h5" align="left" gutterBottom className={classes.title}>
						<span>{label}</span>

						{_.isFunction(onChange) &&
						<TextField
							className={classes.formControl}
							value={value}
							onChange={event => onChange(event)}
							label="Type to search"
							fullWidth
						/>
						}
					</Typography>
				</Grid>

				{!!(buttonText) &&
				<Grid item xs={4} style={{textAlign: 'right'}}>
					<FMPAddButton
						url={url}
						buttonText={buttonText}
						canMakeUpdates={canMakeUpdates}
					/>
				</Grid>
				}
			</Grid>
		);
	}
}

FMPHeadline.propTypes = {
	label: PropTypes.string.isRequired,
	value : PropTypes.string,
	onChange : PropTypes.func,
	classes: PropTypes.object.isRequired,
	url: PropTypes.string,
	buttonText : PropTypes.string,
	canMakeUpdates : PropTypes.bool,
};

export default _.flow([
	withStyles(styles),
])(FMPHeadline);
